export default "__VITE_ASSET__KB4qqNwB__"